import { Component, OnInit, Input, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ReferenceVerificationData } from 'src/app/models/ApplicantDataResponses/ApplicantDataResponses';
import { CraService } from 'src/app/services/cra.service';
import { NgForm } from '@angular/forms';
import { filter, debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-resident-data',
  templateUrl: './resident-data.component.html',
  styleUrls: ['./resident-data.component.less']
})
export class ResidentDataComponent implements OnInit, AfterViewInit {

  constructor(public cra: CraService) { }
  
  @Input() submitted : boolean;
  @Input() model:ReferenceVerificationData;
  @Output() completed : EventEmitter<any> = new EventEmitter();
  @ViewChild(NgForm,{}) form : NgForm;
  
  ngOnInit() {

  }

  ngAfterViewInit(): void {
    this.form.statusChanges.pipe(
      filter(()=>{ return this.form.valid && this.form.dirty; }),
      debounceTime(2500)
    ).subscribe(()=>{
      this.completed.emit('Residence Form Complete');
    })
  }

}
